import Frame from "../../assets/Frame.png";

export default function Baseindex() {
  return (
    <>
      {" "}
      <div className="font-normal mb-4 mt-6 self-center text-transparent bg-clip-text bg-gradient-to-br from-[#E975A8] to-[#726CF8] text-1xl">
        CUSTOMERS
      </div>
      <div className="text-white self-center text-2xl">
        BRANDS WE’VE WORKED WITH
      </div>
      <div>
        {" "}
        <img src={Frame} />
      </div>
    </>
  );
}
